import React from 'react';
import DatePicker from "react-datepicker";

//import "react-datepicker/dist/react-datepicker.css";
import styles from "./baseDatePicker.scss";

function BaseDatePicker(props) {

    const { minDate, maxDate, selectedDate, ...optionalProps } = props;

    const getDateClass = date => {

        const currentDate = new Date();
        currentDate.setHours(0,0,0,0);
        date.setHours(0,0,0,0);
        if(selectedDate && selectedDate!="") {
            selectedDate?.setHours(0,0,0,0);
        }
        const dayClass = [];
        if (date.getTime() === currentDate.getTime()) 
            dayClass.push(styles.currentDay);
        if (date < minDate || date > maxDate) 
            dayClass.push(styles.dayClassdisabled);
        else if (selectedDate && selectedDate !== null && selectedDate !== "" && date.getTime() === selectedDate.getTime()) 
            dayClass.push(styles.selectedDate);
        else 
            dayClass.push(styles.normalDate);
        return dayClass.join(' ');
    }

    return (
        <DatePicker
            selected={selectedDate}
            minDate={minDate}
            maxDate={maxDate}
            calendarClassName={styles.baseCalender}
            dayClassName={getDateClass}
            weekDayClassName={() => styles.weekDayClassName}
            popperClassName={styles.baseCalenderPopper}
            {...optionalProps}
        />
    )
}

export default BaseDatePicker
